import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import LuciPropTypes from "../../propTypes/";
import localize from "../../util/localizeUtils";

const StoryListContainer = styled.div`
  overflow-y: auto;
  border: 1px solid grey;
  box-sizing: border-box;
  height: ${props => (props.height ? props.height : "inherit")};
`;

const ListTitle = styled.div`
  background-color: ${props => props.theme.colors.primary};
  width: 100%;
  padding-left: 0.25rem;
`;

const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
`;

const ListItem = styled.li`
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  padding-left: 0.25rem;
  background-color: ${props =>
    props.selected ? props.theme.colors.secondary : props.theme.background};
  &:hover {
    background-color: ${props =>
      props.selected
        ? props.theme.colors.secondary
        : props.theme.colors.primaryLight};
  }
`;

class StoryList extends Component {
  selectStory = storyId => {
    this.props.selectStory(storyId);
  };
  render() {
    const { storyList, selectedStoryId, openEditor } = this.props;
    if (storyList.length > 0) {
      return (
        <StoryListContainer>
          <ListTitle>{localize("storyListTitle")}</ListTitle>
          <List>
            {storyList.map(story => {
              const storyLabel = story.number
                ? `${story.number} ${story.name}`
                : story.name;
              return (
                <ListItem
                  key={story.id}
                  selected={story.id === selectedStoryId}
                  onClick={() => this.selectStory(story.id)}
                >
                  {storyLabel}
                </ListItem>
              );
            })}
          </List>
        </StoryListContainer>
      );
    }
    return <div />;
  }
}

StoryList.defaultProps = {
  storyList: [],
  selectedStoryId: "",
  selectStory: () => {}
};

StoryList.propTypes = {
  storyList: PropTypes.arrayOf(LuciPropTypes.Story),
  selectedStoryId: PropTypes.string,
  selectStory: PropTypes.func
};

export default StoryList;



// WEBPACK FOOTER //
// ./app/components/RunningOrders/StoryList.js